import { Box, Stack, Typography } from "@mui/material";
import { IsMdScreen, IsXsScreen } from "helpers/hooks";
import { ResourceTypography } from "Modules/Marketing/Resources/Resources.styled";
import { Link as RouterLink } from "react-router-dom";
import { ShButton } from "shared/SharedStyles/ShInputs";
import { ShContainer } from "shared/SharedStyles/ShLayouts";
import CommonQuestionSidebar from "../CommonQuestionSidebar";

export const CalendarHelp = () => {
  const isMdScreen = IsMdScreen();
  const paddingValue = IsXsScreen() ? 1 : 3;

  return (
    <>
      <Stack padding={paddingValue} direction={"row"}>
        <ShContainer maxWidth='xl' margin='auto'>
          <ResourceTypography variant="h5" fontWeight={"bold"} gutterBottom>
            Calendar Management
          </ResourceTypography>
          <ResourceTypography variant="body1" paragraph>
            Manage your interview schedule and hiring timeline efficiently with our integrated calendar system.
            Coordinate interviews, track availability, and ensure smooth communication with candidates.
          </ResourceTypography>

          <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
            Interview Scheduling
          </ResourceTypography>
          <Typography variant="body1" paragraph>
            Schedule interviews with candidates directly through the calendar. Set up one-on-one or panel
            interviews, and automatically sync with your team's availability.
          </Typography>

          <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
            Availability Management
          </ResourceTypography>
          <Typography variant="body1" paragraph>
            Set your availability preferences and let candidates choose interview slots that work for them.
            The system automatically handles time zone conversions and scheduling conflicts.
          </Typography>

          <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
            Calendar Integration
          </ResourceTypography>
          <Typography variant="body1" paragraph>
            Connect your existing calendar (Google, Outlook, etc.) to ensure all your appointments are
            synchronized. Never miss an interview or double-book your time.
          </Typography>

          <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
            Interview Reminders
          </ResourceTypography>
          <Typography variant="body1" paragraph>
            Automated reminders keep everyone informed about upcoming interviews. Candidates and interviewers
            receive notifications and calendar invites automatically.
          </Typography>

          <Box paddingTop={2} paddingBottom={3}>
            <ShButton
              component={RouterLink}
              to="/employer/calendar"
              color="primary"
              variant="contained"
            >
              Access Calendar
            </ShButton>
          </Box>
        </ShContainer>
        {!isMdScreen && <CommonQuestionSidebar />}
      </Stack>
    </>
  );
};

export default CalendarHelp; 